import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenMaterialCreateAction from './communityGardenMaterialCreate.action.json' with { type: 'json' }
import { communityGardenMaterialObject } from '../../communityGardenMaterialObject'

const communityGardenMaterialCreateDefinition = defineAction({
  ...communityGardenMaterialCreateAction,

  input: communityGardenMaterialObject
    .pick({
      id: true,
      communityGardenId: true,
      materialId: true,
      quantity: true,
      createdAt: true,
      updatedAt: true,
    })
    .extend({ id: communityGardenMaterialObject.shape.id.nullish() }),
  output: z.object({ id: communityGardenMaterialObject.shape.id }),
})

export default communityGardenMaterialCreateDefinition
